<template>
  <d-anchor-to :alt-key="false" :name="index" text="#"/>
</template>

<script>
import DAnchorTo from 'dcode/components/DAnchorTo'
import { useStore } from 'vuex'

export default {
  name: 'CPointer',
  components: { DAnchorTo },
  props: {
    name: String
  },
  setup (props) {
    const store = useStore()
    const hash = location.hash
      .replace(/^#/, '')
      .replace(/-[\s\S]+$/ig, '')
    const index = `${hash}-${props.name}`

    store.commit('addPointer', {
      index,
      name: props.name
    })

    return { index }
  }
}
</script>

<style lang="scss"/>
